import { render } from "./Loader.vue?vue&type=template&id=081304ea&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=081304ea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081304ea"]])

export default __exports__